import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const TableUpstreamFlowsFilteredByColumnWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query TableUpstreamFlowsFilteredByColumnWithoutPersonalSpaceQuery($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: { id: $tableId }) {
    columns(filter: { id: $columnId }) {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
